<div class="confirmation">
  <mat-toolbar class="bar">
    <h2 class="confirmation-title" mat-dialog-title>
      {{ configuration.title }}
    </h2>
  </mat-toolbar>
  <mat-dialog-content
    class="confirmation-content"
    [innerHTML]="configuration.question"
  ></mat-dialog-content>
  <mat-dialog-actions class="confirmation-actions">
    <button
      mat-raised-button
      class="button-close"
      [mat-dialog-close]="true"
      *ngIf="!data.errorOldForm"
    >
      Cerrar
    </button>
    <button
      mat-raised-button
      class="button-close"
      (click)="close()"
      *ngIf="data.errorOldForm"
    >
      Cerrar
    </button>
  </mat-dialog-actions>
</div>
